/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Story_Error_FailInputs */

const en_story_error_fail = /** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to share story: ${i?.error}`)
};

const es_story_error_fail = /** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al compartir la historia: ${i?.error}`)
};

const fr_story_error_fail = /** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec du partage de la story : ${i?.error}`)
};

const de_story_error_fail = /** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Teilen der Story: ${i?.error}`)
};

const id_story_error_fail = /** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gagal membagikan cerita: ${i?.error}`)
};

/** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */
const ja_story_error_fail = en_story_error_fail;

/** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */
const zh_story_error_fail = en_story_error_fail;

/** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */
const ar_story_error_fail = en_story_error_fail;

/** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */
const it_story_error_fail = en_story_error_fail;

/** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */
const ru_story_error_fail = en_story_error_fail;

/** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */
const pt_story_error_fail = en_story_error_fail;

/** @type {(inputs: Story_Error_FailInputs) => LocalizedString} */
const ko_story_error_fail = en_story_error_fail;

/**
* | output |
* | --- |
* | "Failed to share story: {error}" |
*
* @param {Story_Error_FailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_error_fail = /** @type {((inputs: Story_Error_FailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Error_FailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_error_fail(inputs)
	if (locale === "es") return es_story_error_fail(inputs)
	if (locale === "fr") return fr_story_error_fail(inputs)
	if (locale === "de") return de_story_error_fail(inputs)
	if (locale === "ja") return ja_story_error_fail(inputs)
	if (locale === "zh") return zh_story_error_fail(inputs)
	if (locale === "ar") return ar_story_error_fail(inputs)
	if (locale === "id") return id_story_error_fail(inputs)
	if (locale === "it") return it_story_error_fail(inputs)
	if (locale === "ru") return ru_story_error_fail(inputs)
	if (locale === "pt") return pt_story_error_fail(inputs)
	return ko_story_error_fail(inputs)
});